export const SELF_EMPLOYED = "0";
export const SELF_EMPLOYED_1099 = "1";
export const W2 = "2";

export default Object.freeze({
  [SELF_EMPLOYED]: "Self-Employed",
  [SELF_EMPLOYED_1099]: "Self-Employed - 1099",
  [W2]: "W2"
});
